<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-4"></a>
<p class="ch-t">Dedication</p>
<p class="noindent">The author dedicates this book to Medal of Honor winner Elmer Charles Bigelow of the US Navy. His citation reads as follows:</p>
<div class="box">
<p class="noindent">For conspicuous gallantry and intrepidity at the risk of his life above and beyond the call of duty while serving on board the USS <em class="italic">Fletcher</em> during action against enemy Japanese forces off Corregidor Island in the Philippines, February 14, 1945. Standing topside when an enemy shell struck the <em class="italic">Fletcher</em>, Bigelow, acting instantly as the deadly projectile exploded into fragments which penetrated the No. 1 gun magazine and set fire to several powder cases, picked up a pair of fire extinguishers and rushed below in a resolute attempt to quell the raging flames. Refusing to waste the precious time required to don rescue-breathing apparatus, he plunged through the blinding smoke billowing out of the magazine hatch and dropped into the blazing compartment. Despite the acrid, burning powder smoke which seared his lungs with every agonizing breath, he worked rapidly and with instinctive sureness and succeeded in quickly extinguishing the fires and in cooling the cases and bulkheads, thereby preventing further damage to the stricken ship. Although he succumbed to his injuries on the following day, BIGELOW, by his dauntless valor, unfaltering skill and prompt action in the critical emergency, had averted a magazine explosion which undoubtedly would have left his ship wallowing at the mercy of the furiously pounding Japanese guns on Corregidor, and his heroic spirit of self-sacrifice in the face of almost certain death enhanced and sustained the highest traditions of the United States Naval Service. He gallantly gave his life in the service of his country.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedication.vue?67e75a7d